import { localize, configure, extend, ValidationProvider, ValidationObserver  } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/fr.json';

const customized = {
  required: 'any.required',
  email: 'string.email',
  confirmed: 'password.match',
}

Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule],
    message: customized[rule] ? customized[rule] : messages[rule] 
  });
});

extend('password', (value) =>
  /(?=.{10})(?=.*\d)(?=.*[a-z])(?=.*[_\W])/.test(value)
)

localize({
  fr: {
    messages: {
      password: 'string.pattern.password',
    },
  },
})

localize('fr')

export default (Vue) => {
  Vue.component('validation-provider', ValidationProvider)
  Vue.component('validation-observer', ValidationObserver)
  configure({
    classes: {
      valid: 'is-valid',
      invalid: 'is-invalid',
      dirty: ['is-dirty', 'is-dirty'],
    }
  })
}